<div class="l-core-contents__tabpanel is-current" id="panel-3" role="tabpanel" aria-labelledby="tab3" tabindex="-1">
  <div class="l-core-contents__inner">
    <!-- [コンテンツ領域2カラム−メイン] -->
    <div class="l-core-contents__main">
      <asw-seat-reservation *ngIf="isDisplayAdvanceSeatReservationInfor"></asw-seat-reservation>
      <asw-junior-pilot *ngIf="isDisplayJuniorPilot"></asw-junior-pilot>
      <asw-consideration-support *ngIf="isDisplaySupport"></asw-consideration-support>
    </div>
    <!-- //[コンテンツ領域2カラム−メイン] -->

    <!-- [コンテンツ領域2カラム−サブ] -->
    <div class="l-core-contents__sub">
      <div class="p-sub-column-layout02">
        <div class="p-sub-column-layout02__body">
          <asw-my-booking-slidebar-menu
            [isItineraryMenuByScreenShow]="isDisplayItineraryOperationMenu"
            [isAnaMemberByScreenShow]="isDisplayNewANAMembership"
            [isRecommentByScreenShow]="isDisplayRecommend"
          ></asw-my-booking-slidebar-menu>
        </div>
      </div>
    </div>
    <!-- //[コンテンツ領域2カラム−サブ] -->
  </div>
</div>
